import { RouteRecordRaw, RouterView } from "vue-router";
import { h } from "vue";

const visitorsRoutes: RouteRecordRaw = {
  path: "/visitors",
  component: () => import("../layouts/SimpleLayout.vue"),
  children: [
    {
      path: "",
      name: "visitorsRoot",
      component: { render: () => h(RouterView) },
      redirect: { name: "visitors" },
      meta: { breadcrumb: "visitors" },
      children: [
        {
          path: "",
          name: "visitors",
          component: () => import("../views/VisitorsView.vue"),
        },
        {
          path: "data",
          name: "visitorsData",
          component: () => import("../views/VisitorsDataView.vue"),
          meta: {
            breadcrumb: "visitors_data",
          },
        },
        {
          path: "new",
          name: "newVisitorRoot",
          component: { render: () => h(RouterView) },
          redirect: { name: "newVisitorSelectCategory" },
          meta: {
            breadcrumb: "new_visitor",
          },
          children: [
            {
              path: "",
              name: "newVisitorSelectCategory",
              component: () => import("../views/NewVisitorSelectCategoryView.vue"),
            },
            {
              path: ":uuid",
              name: "newVisitorForm",
              component: () => import("../views/NewVisitorFormView.vue"),
              props: true,
              meta: {
                breadcrumb: "form",
              },
            },
            {
              path: "edit/:visitorUuid",
              name: "editVisitor",
              component: () => import("../views/NewVisitorFormView.vue"),
              props: true,
              meta: { breadcrumb: "edit_visitor" },
            },
          ],
        },
      ],
    },
  ],
};

export default visitorsRoutes;
